import * as React from 'react';

import { Draggable } from 'react-beautiful-dnd';

import { ListItem, ListItemAvatar, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import styles from './DraggableTaskListItem.scss';


const DraggableTaskListItem = ({ item, index, handleDeleteTask }) => {
    return (
        <Draggable draggableId={item.id} index={index}>
            {(provided, snapshot) => (
                <ListItem
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className={`${styles.task__item} ${snapshot.isDragging ? styles.draggingListItem : ''}`}
                >
                    <ListItemAvatar className={styles.avatar}><DragIndicatorIcon /></ListItemAvatar>

                    <Typography style={{ width: '100%' }} variant="h5">{item.taskName}</Typography>

                    <span onClick={() => handleDeleteTask(item)} data-testid="Task__CloseIcon"><CloseIcon className={styles.task__closeBtn} /></span>
                </ListItem>
            )}
        </Draggable>
    );
};

export default DraggableTaskListItem;